export default "__VITE_ASSET__fC4G1fg3__"